// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"795d935c","667":"29d6c9f9","977":"703caf78"}[chunkId] + ".chunk.js";
};